import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BroadcastMessageTypeService } from '../../../../../services/broadcast-message-type.service';
import { BroadcastMessageService } from '../../../../../services/broadcast-message.service';
import { SharedService } from '../../../../../services/shared.service';
import { MESSAGE } from '../../../../../utils/messages';

@Component({
  selector: 'app-message',
  templateUrl: './broadcast-message.component.html',
  styleUrls: ['./broadcast-message.component.scss'],
})
export class BroadcastMessageComponent implements OnInit, OnDestroy {
  type$ = this.broadcastMessageTypeService.findAll();

  form: FormGroup = this.fb.group({
    type: [null, Validators.required],
    infoMessage: [null, Validators.required],
    audioMessage: [null, Validators.required],
  });

  private readonly subscription: Subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private broadcastMessageTypeService: BroadcastMessageTypeService,
    private broadcastMessageService: BroadcastMessageService,
    private sharedService: SharedService,
    public dialogRef: MatDialogRef<BroadcastMessageComponent>,
  ) {}

  ngOnInit(): void {}

  submit() {
    if (this.form.valid) {
      this.form.disable();
      const { type, infoMessage, audioMessage } = this.form.value;
      this.broadcastMessageService.create({ broadcastMessageTypeId: type.id, infoMessage, audioMessage }).subscribe({
        next: () => {
          this.dialogRef.close();
          this.form.reset();
          this.form.enable();
          this.sharedService.showSuccessMessage(MESSAGE.success_message);
          this.sharedService.reloadGrid();
        },
        error: (error: any) => {
          this.form.enable();
          error.errorMessages && error.errorMessages.length
            ? this.sharedService.showMessage(error.appCode)
            : this.sharedService.showMessage(MESSAGE.RUNTIME_ERROR);
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
